import React from "react";

export const Hero = () => {
  return (
    <div className="hero-container max-width">
      <div className="left-item"></div>
      <div className="right-item">
        <div className="right-image">
<div className="hero-text">
  <h1>fd</h1>
</div>
        </div>
      </div>
    </div>
  );
};
